module.exports = __webpack_public_path__ + "img/IMG_0533.3dc7671c.png";